// Stands in for the multiplier while a sentence is translated, so the figure can be found again
// in whatever word order the language uses. A private-use character never occurs in a translation.
export const MULTIPLIER_MARKER = '';

// A translated sentence cut around its multiplier, so a surface can colour the figure alone.
export interface MultiplierSentence {
  before: string;
  figure: string;
  after: string;
}

// Splits a sentence translated with `{ multiplier: MULTIPLIER_MARKER }`. The figure takes an "x"
// that directly follows the marker ("7x"); a language that words the multiple another way keeps
// only the number as the figure and the rest of its sentence as plain text. A translation that
// dropped the placeholder comes back whole in `before`, with no figure.
export function splitAtMultiplier(sentence: string, multiplier: string): MultiplierSentence {
  const at = sentence.indexOf(MULTIPLIER_MARKER);
  if (at === -1) {
    return { before: sentence, figure: '', after: '' };
  }
  const rest = sentence.slice(at + MULTIPLIER_MARKER.length);
  const suffix = rest.startsWith('x') ? 'x' : '';
  return {
    before: sentence.slice(0, at),
    figure: multiplier + suffix,
    after: rest.slice(suffix.length),
  };
}
